/* Portal does not work for server side rendering and screenshot tests
 *  to account for this you should trigger the inline property or not use portal
 *  the element is a screenshot test or doesn't have a DOM.
 *  Use shouldUsePortal to help you determine that case
 */

export default function shouldUsePortal() {
    return typeof document !== 'undefined' && !global.screenshot;
}
